import BizLeaderMobileDashboard from "../../../../components/AssetManagement/Overview/BusinessLeaderDashboard/BizLeaderMobileDashboard/BizLeaderMobileDashboard";

const BizLeaderDashMobileScreen = () => {
  return (
    <div>
      <BizLeaderMobileDashboard />
    </div>
  );
};

export default BizLeaderDashMobileScreen;
